// Only product columns scroll. Keep the separate labels aligned with native table rows.
class RoutineBenefitsLayout extends HTMLElement {
  connectedCallback() {
    this.observer?.disconnect();
    const labels = [...this.querySelectorAll('[data-routine-label]')];
    const rows = [...this.querySelectorAll('[data-routine-row]')];
    const align = () => {
      // Clear previous sizes so rows can shrink after responsive or authoring changes.
      for (const element of [...labels, ...rows]) element.style.height = '';
      const heights = rows.map((row, index) => Math.max(
        row.getBoundingClientRect().height,
        labels[index]?.getBoundingClientRect().height || 0,
      ));
      rows.forEach((row, index) => {
        row.style.height = `${heights[index]}px`;
        if (labels[index]) labels[index].style.height = `${heights[index]}px`;
      });
    };
    this.observer = new ResizeObserver(() => {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(align);
    });
    this.observer.observe(this);
    const table = this.querySelector('table');
    if (table) this.observer.observe(table);
    for (const content of this.querySelectorAll('[data-routine-label-content]')) this.observer.observe(content);
    align();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    cancelAnimationFrame(this.frame);
  }
}

if (!customElements.get('routine-benefits-layout')) {
  customElements.define('routine-benefits-layout', RoutineBenefitsLayout);
}
